if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
      this.dataSectionIndex = this.dataset.sectionIndex;
      if (this.dataSectionIndex !== "1") {
        this.initializeScrollAnimationTrigger();
      } else {
        this.initializeUpdateTitleAnimation();
      }
    }

    onIntersection(elements, observer) {
      elements.forEach((entry, index) => {
          if (entry.isIntersecting) {
          const elementTarget = entry.target;
          elementTarget.dataset.active = "true";
          elementTarget.setAttribute('style', `--animation-order: ${index + 1};`);

          const textElements = elementTarget.querySelectorAll('.text-animation-item');
            textElements.forEach((textEl) => {
              textEl.classList.add('is-visible');
            });
          observer.unobserve(elementTarget);
          }
      });
}

    initializeScrollAnimationTrigger(rootEl = document) {
      const animationContainers = Array.from(rootEl.querySelectorAll(".animated-list-wrapper"));

      animationContainers.forEach((container) => {
          const animationTriggerElements = Array.from(container.querySelectorAll(".anm-reveal-item-collection[data-active='false']"));
          if (animationTriggerElements.length === 0) return;
      

          const observer = new IntersectionObserver((entries, obs) => {
              this.onIntersection(entries, obs);
          }, {
          rootMargin: '0px 0px -50px 0px'
          });

          animationTriggerElements.forEach((element) => observer.observe(element));
      });
    }

    initializeUpdateTitleAnimation(rootEl = document) {
      const titleElements = Array.from(rootEl.querySelectorAll(".text-animation-item"));
      titleElements.forEach((titleEl) => {
        titleEl.classList.add('is-visible');
      });
    }
  }
  customElements.define('collection-list', CollectionList);
}
function parseProvinceSuffixes(raw) {
  const map = {};
  if (!raw) return map;
  raw.split('\n').forEach(line => {
    const idx = line.indexOf(':');
    if (idx === -1) return;
    const code = line.slice(0, idx).trim().toUpperCase();
    const suffix = line.slice(idx + 1).trim();
    if (code && suffix) map[code] = suffix;
  });
  return map;
}

function parseProvinceSuffixes(raw) {
  const map = {};
  if (!raw) return map;
  raw.split('\n').forEach(line => {
    const idx = line.indexOf(':');
    if (idx === -1) return;
    const code = line.slice(0, idx).trim();
    const suffix = line.slice(idx + 1).trim();
    if (code && suffix) map[code] = suffix;
  });
  return map;
}

function parseProvinceSuffixes(raw) {
  const map = {};
  if (!raw) return map;
  raw.split('\n').forEach(line => {
    const idx = line.indexOf(':');
    if (idx === -1) return;
    const code = line.slice(0, idx).trim();
    const suffix = line.slice(idx + 1).trim();
    if (code && suffix) map[code] = suffix;
  });
  return map;
}

function updateCollectionCardLinks(taxTag) {
  document.querySelectorAll('.card-collection__link[data-province-links]').forEach(link => {
    const map = parseProvinceSuffixes(link.dataset.provinceLinks);
    const base = link.dataset.defaultLink;
    const suffix = map[taxTag];
    if (!base) return;
    if (!suffix) {
      link.setAttribute('href', base);
      return;
    }
    const trimmedBase = base.replace(/\/$/, '');
    const trimmedSuffix = suffix.replace(/^\//, '');
    link.setAttribute('href', `${trimmedBase}/${trimmedSuffix}`);
  });
}

function initProvinceLinks() {
  var selection = window.Maximize.getProvinceSelection();
  if (selection && selection.taxTag) {
    updateCollectionCardLinks(selection.taxTag);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProvinceLinks);
} else {
  initProvinceLinks();
}

document.addEventListener('province-selection-changed', (event) => {
  updateCollectionCardLinks(event.detail.taxTag);
});